import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4645e806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-page__content-container" }
const _hoisted_2 = { class: "news-page__header" }
const _hoisted_3 = { class: "news-page__title" }

import { computed, onMounted, onUnmounted } from 'vue';
import { IonContent, IonPage, IonText, useIonRouter } from '@ionic/vue';
import { useI18n } from 'vue-i18n';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { Icons } from '@/enums/Icons';
import { Lang } from '@/enums/Lang';
import { RouteName } from '@/enums/Router';
import { Platform } from '@/enums/Platform';
import useNewsSettings from '@/composables/useNewsSettings';
import useLangSettings from '@/composables/useLangSettings';
import BaseButton from '@/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';
import NewsSection from '@/components/News/NewsSection.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsPage',
  setup(__props) {

const langSettings = useLangSettings();
const router = useIonRouter();

const { t } = useI18n();

const data = computed(() => {
  let news = [
    {
      title: t('news.page.software_title'),
      items: [
        {
          imageUrl: require('@/assets/images/news-page/cobra.jpg'),
          title: t('news.articles.cobra_software.title'),
          content: t('news.articles.cobra_software.description'),
          seeMoreLink: t('news.articles.cobra_software.link'),
        },
      ],
      actions: [
        {
          title: t('news.actions.cobra_software.label'),
          link: t('news.actions.cobra_software.link'),
          icon: Icons.Envelope,
        },
      ],
    },
    {
      title: t('news.page.training_title'),
      items: [
        {
          imageUrl: require('@/assets/images/news-page/academy.jpg'),
          title: t('news.articles.cetim_academy.title'),
          content: t('news.articles.cetim_academy.description'),
          seeMoreLink: t('news.articles.cetim_academy.link'),
        },
      ],
      actions: [
        {
          title: t('news.actions.cetim_academy.label'),
          link: t('news.actions.cetim_academy.link'),
          icon: Icons.Envelope,
        },
      ],
    },
    {
      title: t('news.page.issues_title'),
      items: [
        {
          imageUrl: require('@/assets/images/news-page/integrity.jpg'),
          title: t('news.articles.cetim_integrity.title'),
          content: t('news.articles.cetim_integrity.description'),
          seeMoreLink: t('news.articles.cetim_integrity.link'),
        },
      ],
      actions: [
        {
          title: t('news.actions.cetim_integrity.label'),
          link: t('news.actions.cetim_integrity.link'),
          icon: Icons.Envelope,
        },
      ],
    },
    {
      title: t('news.page.question_title'),
      actions: [
        {
          title: t('news.actions.website.label'),
          link: t('news.actions.website.link'),
          icon: Icons.Info,
        },
        {
          title: t('news.actions.mail.label'),
          link: t('news.actions.mail.link'),
          icon: Icons.Envelope,
        },
        {
          title: t('news.actions.call.label'),
          link: t('news.actions.call.link'),
          icon: Icons.Phone,
        },
        {
          title: t('news.actions.info.label'),
          link: t('news.actions.info.link'),
          icon: Icons.Info,
        },
      ],
    },
  ];

  if (langSettings.currentLocale() === Lang.Fr.Iso) {
    news.splice(0, 0, assembliesDaysSection);
    news.splice(news.length - 1, 0, futureSection);
  }

  return news;
});

const futureSection = {
  title: t('news.page.future_title'),
  items: [
    {
      imageUrl: require('@/assets/images/news-page/quatrium.jpg'),
      imageStyle: {
        'object-fit': 'contain',
      },
      title: t('news.articles.quatrium.title'),
      content: t('news.articles.quatrium.description'),
      seeMoreLink: t('news.articles.quatrium.link'),
    },
  ],
  actions: [
    {
      title: t('news.actions.quatrium.label'),
      link: t('news.actions.quatrium.link'),
      icon: Icons.Envelope,
    },
  ],
};

const assembliesDaysSection = {
  title: t('news.page.assembly_days_title'),
  items: [
    {
      imageUrl: require('@/assets/images/news-page/assembly.png'),
      title: t('news.articles.assemblies_days.title'),
      content: t('news.articles.assemblies_days.description'),
      seeMoreLink: t('news.articles.assemblies_days.link'),
    },
  ],
  actions: [],
};

const goBack = () => {
  if (Capacitor.getPlatform() === Platform.WEB) {
    router.push({ name: RouteName.HOME });
  } else {
    router.back();
  }
};

onMounted(() => {
  useNewsSettings().checkLastVisit();

  if (Capacitor.getPlatform() === Platform.IOS) {
    StatusBar.setStyle({ style: Style.Dark });
  }
});

onUnmounted(() => {
  if (Capacitor.getPlatform() === Platform.IOS) {
    StatusBar.setStyle({ style: Style.Light });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), { class: "news-page" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        class: "news-page__content",
        color: "primary",
        forceOverscroll: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("header", _hoisted_2, [
              _createVNode(BaseButton, {
                class: "news-page__close-button",
                color: "primary",
                onClick: goBack
              }, {
                default: _withCtx(() => [
                  _createVNode(BaseIcon, {
                    class: "news-page__close-button-icon",
                    icon: _unref(Icons).Cross
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(IonText), { class: "news-page__title-container news-page__title-container--main-title" }, {
              default: _withCtx(() => [
                _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('news.page.title')), 1)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (section, index) => {
              return (_openBlock(), _createBlock(NewsSection, {
                class: "news-page__section",
                key: `section-${index}`,
                section: section
              }, null, 8, ["section"]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})